'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var extractDataFromBlock = require('../../../utils/extract-data-from-block.js');

var validateOffsetAndLength = require('../../../utils/validate-offset-and-length.js');

var ipfsUnixfs = require('ipfs-unixfs');

var errCode = require('err-code');

var dagPb = require('@ipld/dag-pb');

var dagCbor = require('@ipld/dag-cbor');

var raw = require('multiformats/codecs/raw');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var dagPb__namespace = /*#__PURE__*/_interopNamespace(dagPb);

var dagCbor__namespace = /*#__PURE__*/_interopNamespace(dagCbor);

var raw__namespace = /*#__PURE__*/_interopNamespace(raw);

function emitBytes(_x, _x2, _x3, _x4) {
  return _emitBytes.apply(this, arguments);
}

function _emitBytes() {
  _emitBytes = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blockstore, node, start, end) {
    var streamPosition,
        options,
        buf,
        file,
        _buf,
        childStart,
        i,
        childLink,
        childEnd,
        block,
        child,
        _iteratorAbruptCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _buf2,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            streamPosition = _args.length > 4 && _args[4] !== undefined ? _args[4] : 0;
            options = _args.length > 5 ? _args[5] : undefined;

            if (!(node instanceof Uint8Array)) {
              _context.next = 9;
              break;
            }

            buf = extractDataFromBlock(node, streamPosition, start, end);

            if (!buf.length) {
              _context.next = 7;
              break;
            }

            _context.next = 7;
            return buf;

          case 7:
            streamPosition += buf.length;
            return _context.abrupt("return", streamPosition);

          case 9:
            if (!(node.Data == null)) {
              _context.next = 11;
              break;
            }

            throw errCode__default['default'](new Error('no data in PBNode'), 'ERR_NOT_UNIXFS');

          case 11:
            _context.prev = 11;
            file = ipfsUnixfs.UnixFS.unmarshal(node.Data);
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](11);
            throw errCode__default['default'](_context.t0, 'ERR_NOT_UNIXFS');

          case 18:
            if (!(file.data && file.data.length)) {
              _context.next = 24;
              break;
            }

            _buf = extractDataFromBlock(file.data, streamPosition, start, end);

            if (!_buf.length) {
              _context.next = 23;
              break;
            }

            _context.next = 23;
            return _buf;

          case 23:
            streamPosition += file.data.length;

          case 24:
            childStart = streamPosition;
            i = 0;

          case 26:
            if (!(i < node.Links.length)) {
              _context.next = 83;
              break;
            }

            childLink = node.Links[i];
            childEnd = streamPosition + file.blockSizes[i];

            if (!(start >= childStart && start < childEnd || end > childStart && end <= childEnd || start < childStart && end > childEnd)) {
              _context.next = 78;
              break;
            }

            _context.next = 32;
            return _awaitAsyncGenerator(blockstore.get(childLink.Hash, {
              signal: options.signal
            }));

          case 32:
            block = _context.sent;
            child = void 0;
            _context.t1 = childLink.Hash.code;
            _context.next = _context.t1 === dagPb__namespace.code ? 37 : _context.t1 === raw__namespace.code ? 41 : _context.t1 === dagCbor__namespace.code ? 43 : 47;
            break;

          case 37:
            _context.next = 39;
            return _awaitAsyncGenerator(dagPb__namespace.decode(block));

          case 39:
            child = _context.sent;
            return _context.abrupt("break", 48);

          case 41:
            child = block;
            return _context.abrupt("break", 48);

          case 43:
            _context.next = 45;
            return _awaitAsyncGenerator(dagCbor__namespace.decode(block));

          case 45:
            child = _context.sent;
            return _context.abrupt("break", 48);

          case 47:
            throw Error("Unsupported codec: ".concat(childLink.Hash.code));

          case 48:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 50;
            _iterator = _asyncIterator(emitBytes(blockstore, child, start, end, streamPosition, options));

          case 52:
            _context.next = 54;
            return _awaitAsyncGenerator(_iterator.next());

          case 54:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 62;
              break;
            }

            _buf2 = _step.value;
            streamPosition += _buf2.length;
            _context.next = 59;
            return _buf2;

          case 59:
            _iteratorAbruptCompletion = false;
            _context.next = 52;
            break;

          case 62:
            _context.next = 68;
            break;

          case 64:
            _context.prev = 64;
            _context.t2 = _context["catch"](50);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 68:
            _context.prev = 68;
            _context.prev = 69;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 73;
              break;
            }

            _context.next = 73;
            return _awaitAsyncGenerator(_iterator.return());

          case 73:
            _context.prev = 73;

            if (!_didIteratorError) {
              _context.next = 76;
              break;
            }

            throw _iteratorError;

          case 76:
            return _context.finish(73);

          case 77:
            return _context.finish(68);

          case 78:
            streamPosition = childEnd;
            childStart = childEnd + 1;

          case 80:
            i++;
            _context.next = 26;
            break;

          case 83:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[11, 15], [50, 64, 68, 78], [69,, 73, 77]]);
  }));
  return _emitBytes.apply(this, arguments);
}

var fileContent = function fileContent(cid, node, unixfs, path, resolve, depth, blockstore) {
  function yieldFileContent() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fileSize = unixfs.fileSize();

    if (fileSize === undefined) {
      throw new Error('File was a directory');
    }

    var _validateOffsetAndLen = validateOffsetAndLength(fileSize, options.offset, options.length),
        offset = _validateOffsetAndLen.offset,
        length = _validateOffsetAndLen.length;

    var start = offset;
    var end = offset + length;
    return emitBytes(blockstore, node, start, end, 0, options);
  }

  return yieldFileContent;
};

module.exports = fileContent;